export default __webpack_public_path__ + "static/media/dima.785afb2d.jpg";